import { number, object, string } from "yup";

export default object().shape({
  portfolio: object()
    .shape({
      id: number().required("Required"),
    })
    .required("Required"),
  pointPerson: object().shape({
    id: number().required("Required"),
  }),
  category: string(),
  address: string(),
  city: string(),
  zip: string(),
  country: object().shape({
    id: number(),
    name: string(),
  }),
});
